import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { EmploymentStatusRequest } from "../../../../orchestrator-api-client";

export const submitEmploymentReducer = (
  state: CustomerState,
  action: PayloadAction<EmploymentStatusRequest>,
) => {
  state.job.employmentStatus = action.payload.employmentStatus!; // TODO: Must be set as non-nullable on swagger
};
